<script setup lang="ts">
  import {
    computed,
    nextTick,
    onActivated,
    onBeforeUnmount,
    onMounted,
    reactive,
    ref,
    watch,
  } from 'vue';
  import {
    actions as actionTypes,
    useUserComponent,
    useHelpers,
    createComponentScope,
    Resource,
    uniqueID,
  } from '@integro/core';
  import type { IAppHelpers } from '@integro/core';
  import * as _ from 'lodash';

  defineOptions({
    name: 'AppTabbedMainMenu',
  });

  const componentMetadata = {
    kind: 'usercontrol',
  };

  const emit = defineEmits(['reload', 'close', 'save']);

  const props = defineProps({});

  const {
    $app,
    $fn,
    $i18n,
    $store,
    $config,
    $imodal,
    $notification,
    $tabs,
    $route,
    $router,
    gettext,
    pgettext,
    ngettext,
    npgettext,
    schemaDefaults,
    getSchema,
    searchDataSource,
    randomElementId,
    datetime,
    date,
    time,
    number,
    money,
    distance,
    username,
    filesize,
  } = useHelpers();

  const ux = ref({
    loadingPlaceholder: 'none',
  });

  const $data = computed(() => ({
    ux: ux.value,
  }));

  const {
    loading,
    error,
    loaded,
    reloading,
    showLoadingIndicator,
    loadDataThrottled,
    friendlyName,
    loadData,
    touchLastLoaded,
    handleError,
    setData,
    forms,
    registerForm,
    unregisterForm,
    canLoadData,
    isModalComponent,
    modalName,
    pageDocument: _pageDocument,
    routeTab,
    ux: _ux,
    componentMetadata: _componentMetadata,
    $uid,
    lastLoaded,
  } = useUserComponent(props, {
    metadata: componentMetadata,
    dataSpecs: [{ name: 'ux' }],
    loaders: {},
    ux: { loadingPlaceholder: 'none' },
    dataRefs: { ux },
  });

  const $component = createComponentScope(
    {
      $app,
      $fn,
      $i18n,
      $store,
      $imodal,
      $notification,
      $tabs,
      $router,
    } as IAppHelpers,
    {
      emit,
      forms,
      error,
      isModalComponent,
      modalName,
      componentMetadata,
      loadData,
      registerForm,
      unregisterForm,
      setData,
      touchLastLoaded,
      handleError,
    }
  );

  const act_1655522927138420_showModal_xcsmxcbk2_getActionArgs = async (
    $event
  ) => {
    return {
      name: 'CreateInvoice',
      props: {
        invoiceKind: 'outgoing',
      },
    };
  };
  const act_8017751657993364_showModal_h8hjm9996_getActionArgs = async (
    $event
  ) => {
    return {
      name: 'CreateInvoice',
      props: {
        invoiceKind: 'incoming',
      },
    };
  };
  const act_7020200672081126_showModal_qyrgkka00_getActionArgs = async (
    $event
  ) => {
    return {
      name: 'Payment',
      props: {
        transactionKind: 'cash_book',
        transactionType: 'deposit',
      },
    };
  };
  const act_1664577178787908_showModal_862yp692m_getActionArgs = async (
    $event
  ) => {
    return {
      name: 'Payment',
      props: {
        transactionKind: 'cash_book',
        transactionType: 'payment',
      },
    };
  };
  const act_1573730003820863_showModal_rj6eh3vpi_getActionArgs = async (
    $event
  ) => {
    return {
      name: 'Payment',
      props: {
        transactionKind: 'bank',
      },
    };
  };
  const act_3537731272337912_showModal_bz9ekncuh_getActionArgs = async (
    $event
  ) => {
    return {
      name: 'AccountStatementReport',
    };
  };
  const act_8518026866742051_showModal_q8b6ssm1e_getActionArgs = async (
    $event
  ) => {
    return {
      name: 'MCreateFixedAsset',
      props: {
        assetType: 'general',
      },
    };
  };
  const act_8538961222052157_showModal_gbnc1ozoa_getActionArgs = async (
    $event
  ) => {
    return {
      name: 'MCreateFixedAsset',
      props: {
        assetType: 'waste_bin',
      },
    };
  };
  const act_8522767679599795_showModal_jv4qzlpjn_getActionArgs = async (
    $event
  ) => {
    return {
      name: 'CreateMeter',
    };
  };
  const act_8019833267266433_showModal_qaa98l8rg_getActionArgs = async (
    $event
  ) => {
    return {
      name: 'ReplaceMeter',
    };
  };
  const act_138351816140972_showModal_wdvjyhoen_getActionArgs = async (
    $event
  ) => {
    return {
      name: 'MeterDataExchange',
    };
  };
  const act_6701963263207099_showModal_unlgkwskk_getActionArgs = async (
    $event
  ) => {
    return {
      name: 'CreateContract',
    };
  };
  const act_4779871833378228_showModal_rxnjnatfe_getActionArgs = async (
    $event
  ) => {
    return {
      name: 'BillingRules',
    };
  };
  const act_6148282284529915_showModal_kv25pfbu9_getActionArgs = async (
    $event
  ) => {
    return {
      name: 'Worksheet',
      props: {
        size: 'lg',
      },
    };
  };
  const act_4005034396254503_showModal_ewwo93lm6_getActionArgs = async (
    $event
  ) => {
    return {
      name: 'CreateProduct',
    };
  };
  const act_4368686527809996_showModal_lp197zlxn_getActionArgs = async (
    $event
  ) => {
    return {
      name: 'Tariffs',
    };
  };
  const act_6106646942169597_showModal_ldw1ywni8_getActionArgs = async (
    $event
  ) => {
    return {
      name: 'CreateRental',
    };
  };
  const act_6292004841848118_showModal_s6apwgzms_getActionArgs = async (
    $event
  ) => {
    return {
      name: 'CreateProject',
    };
  };
  const act_968355720031679_showModal_ygyb1id88_getActionArgs = async (
    $event
  ) => {
    return {
      name: 'CreateProperty',
    };
  };
  const act_3472122993559495_showModal_fcv1q69ao_getActionArgs = async (
    $event
  ) => {
    return {
      name: 'CreateCompany',
      props: {
        role: 'partner',
      },
    };
  };
  const act_2096702845922487_showModal_056vpeo7c_getActionArgs = async (
    $event
  ) => {
    return {
      name: 'CreateCompany',
      props: {
        role: 'own',
      },
    };
  };

  const act_7315092382398562_reloadComponentData_nv8d9gqdl =
    new actionTypes.ReloadComponentDataAction({});
  const inst_evh_7315092382398562_reload_llfuw2t7y =
    new actionTypes.EventHandlerImpl({
      action: act_7315092382398562_reloadComponentData_nv8d9gqdl,
      event: 'reload',
      displayName: 'reloadComponentData',
    });
  const inst_evh_7315092382398562_reload = new actionTypes.EventHandlerGroup({
    handlers: [inst_evh_7315092382398562_reload_llfuw2t7y],
    event: 'reload',
  });
  const act_1655522927138420_showModal_xcsmxcbk2 =
    new actionTypes.ShowModalAction({
      actionArgs: act_1655522927138420_showModal_xcsmxcbk2_getActionArgs,
    });
  const inst_evh_1655522927138420_clickPrevent_7pkd4pwra =
    new actionTypes.EventHandlerImpl({
      action: act_1655522927138420_showModal_xcsmxcbk2,
      event: 'click.prevent',
      displayName: 'showModal',
    });
  const inst_evh_1655522927138420_clickPrevent =
    new actionTypes.EventHandlerGroup({
      handlers: [inst_evh_1655522927138420_clickPrevent_7pkd4pwra],
      event: 'click.prevent',
    });
  const act_8017751657993364_showModal_h8hjm9996 =
    new actionTypes.ShowModalAction({
      actionArgs: act_8017751657993364_showModal_h8hjm9996_getActionArgs,
    });
  const inst_evh_8017751657993364_clickPrevent_qi77gncy1 =
    new actionTypes.EventHandlerImpl({
      action: act_8017751657993364_showModal_h8hjm9996,
      event: 'click.prevent',
      displayName: 'showModal',
    });
  const inst_evh_8017751657993364_clickPrevent =
    new actionTypes.EventHandlerGroup({
      handlers: [inst_evh_8017751657993364_clickPrevent_qi77gncy1],
      event: 'click.prevent',
    });
  const act_7020200672081126_showModal_qyrgkka00 =
    new actionTypes.ShowModalAction({
      actionArgs: act_7020200672081126_showModal_qyrgkka00_getActionArgs,
    });
  const inst_evh_7020200672081126_clickPrevent_4ldqq12vd =
    new actionTypes.EventHandlerImpl({
      action: act_7020200672081126_showModal_qyrgkka00,
      event: 'click.prevent',
      displayName: 'showModal',
    });
  const inst_evh_7020200672081126_clickPrevent =
    new actionTypes.EventHandlerGroup({
      handlers: [inst_evh_7020200672081126_clickPrevent_4ldqq12vd],
      event: 'click.prevent',
    });
  const act_1664577178787908_showModal_862yp692m =
    new actionTypes.ShowModalAction({
      actionArgs: act_1664577178787908_showModal_862yp692m_getActionArgs,
    });
  const inst_evh_1664577178787908_clickPrevent_mvnp7o6ni =
    new actionTypes.EventHandlerImpl({
      action: act_1664577178787908_showModal_862yp692m,
      event: 'click.prevent',
      displayName: 'showModal',
    });
  const inst_evh_1664577178787908_clickPrevent =
    new actionTypes.EventHandlerGroup({
      handlers: [inst_evh_1664577178787908_clickPrevent_mvnp7o6ni],
      event: 'click.prevent',
    });
  const act_1573730003820863_showModal_rj6eh3vpi =
    new actionTypes.ShowModalAction({
      actionArgs: act_1573730003820863_showModal_rj6eh3vpi_getActionArgs,
    });
  const inst_evh_1573730003820863_clickPrevent_t6tlhg554 =
    new actionTypes.EventHandlerImpl({
      action: act_1573730003820863_showModal_rj6eh3vpi,
      event: 'click.prevent',
      displayName: 'showModal',
    });
  const inst_evh_1573730003820863_clickPrevent =
    new actionTypes.EventHandlerGroup({
      handlers: [inst_evh_1573730003820863_clickPrevent_t6tlhg554],
      event: 'click.prevent',
    });
  const act_3537731272337912_showModal_bz9ekncuh =
    new actionTypes.ShowModalAction({
      actionArgs: act_3537731272337912_showModal_bz9ekncuh_getActionArgs,
    });
  const inst_evh_3537731272337912_clickPrevent_h5frth5eb =
    new actionTypes.EventHandlerImpl({
      action: act_3537731272337912_showModal_bz9ekncuh,
      event: 'click.prevent',
      displayName: 'showModal',
    });
  const inst_evh_3537731272337912_clickPrevent =
    new actionTypes.EventHandlerGroup({
      handlers: [inst_evh_3537731272337912_clickPrevent_h5frth5eb],
      event: 'click.prevent',
    });
  const act_8518026866742051_showModal_q8b6ssm1e =
    new actionTypes.ShowModalAction({
      actionArgs: act_8518026866742051_showModal_q8b6ssm1e_getActionArgs,
    });
  const inst_evh_8518026866742051_clickPrevent_owbtpmvk6 =
    new actionTypes.EventHandlerImpl({
      action: act_8518026866742051_showModal_q8b6ssm1e,
      event: 'click.prevent',
      displayName: 'showModal',
    });
  const inst_evh_8518026866742051_clickPrevent =
    new actionTypes.EventHandlerGroup({
      handlers: [inst_evh_8518026866742051_clickPrevent_owbtpmvk6],
      event: 'click.prevent',
    });
  const act_8538961222052157_showModal_gbnc1ozoa =
    new actionTypes.ShowModalAction({
      actionArgs: act_8538961222052157_showModal_gbnc1ozoa_getActionArgs,
    });
  const inst_evh_8538961222052157_clickPrevent_m65qly0to =
    new actionTypes.EventHandlerImpl({
      action: act_8538961222052157_showModal_gbnc1ozoa,
      event: 'click.prevent',
      displayName: 'showModal',
    });
  const inst_evh_8538961222052157_clickPrevent =
    new actionTypes.EventHandlerGroup({
      handlers: [inst_evh_8538961222052157_clickPrevent_m65qly0to],
      event: 'click.prevent',
    });
  const act_8522767679599795_showModal_jv4qzlpjn =
    new actionTypes.ShowModalAction({
      actionArgs: act_8522767679599795_showModal_jv4qzlpjn_getActionArgs,
    });
  const inst_evh_8522767679599795_clickPrevent_pd73pwu5k =
    new actionTypes.EventHandlerImpl({
      action: act_8522767679599795_showModal_jv4qzlpjn,
      event: 'click.prevent',
      displayName: 'showModal',
    });
  const inst_evh_8522767679599795_clickPrevent =
    new actionTypes.EventHandlerGroup({
      handlers: [inst_evh_8522767679599795_clickPrevent_pd73pwu5k],
      event: 'click.prevent',
    });
  const act_8019833267266433_showModal_qaa98l8rg =
    new actionTypes.ShowModalAction({
      actionArgs: act_8019833267266433_showModal_qaa98l8rg_getActionArgs,
    });
  const inst_evh_8019833267266433_clickPrevent_2ygr9ai6s =
    new actionTypes.EventHandlerImpl({
      action: act_8019833267266433_showModal_qaa98l8rg,
      event: 'click.prevent',
      displayName: 'showModal',
    });
  const inst_evh_8019833267266433_clickPrevent =
    new actionTypes.EventHandlerGroup({
      handlers: [inst_evh_8019833267266433_clickPrevent_2ygr9ai6s],
      event: 'click.prevent',
    });
  const act_138351816140972_showModal_wdvjyhoen =
    new actionTypes.ShowModalAction({
      actionArgs: act_138351816140972_showModal_wdvjyhoen_getActionArgs,
    });
  const inst_evh_138351816140972_clickPrevent_jwzj2erz8 =
    new actionTypes.EventHandlerImpl({
      action: act_138351816140972_showModal_wdvjyhoen,
      event: 'click.prevent',
      displayName: 'showModal',
    });
  const inst_evh_138351816140972_clickPrevent =
    new actionTypes.EventHandlerGroup({
      handlers: [inst_evh_138351816140972_clickPrevent_jwzj2erz8],
      event: 'click.prevent',
    });
  const act_6701963263207099_showModal_unlgkwskk =
    new actionTypes.ShowModalAction({
      actionArgs: act_6701963263207099_showModal_unlgkwskk_getActionArgs,
    });
  const inst_evh_6701963263207099_clickPrevent_4t2zuwfsv =
    new actionTypes.EventHandlerImpl({
      action: act_6701963263207099_showModal_unlgkwskk,
      event: 'click.prevent',
      displayName: 'showModal',
    });
  const inst_evh_6701963263207099_clickPrevent =
    new actionTypes.EventHandlerGroup({
      handlers: [inst_evh_6701963263207099_clickPrevent_4t2zuwfsv],
      event: 'click.prevent',
    });
  const act_4779871833378228_showModal_rxnjnatfe =
    new actionTypes.ShowModalAction({
      actionArgs: act_4779871833378228_showModal_rxnjnatfe_getActionArgs,
    });
  const inst_evh_4779871833378228_clickPrevent_koahp7r6y =
    new actionTypes.EventHandlerImpl({
      action: act_4779871833378228_showModal_rxnjnatfe,
      event: 'click.prevent',
      displayName: 'showModal',
    });
  const inst_evh_4779871833378228_clickPrevent =
    new actionTypes.EventHandlerGroup({
      handlers: [inst_evh_4779871833378228_clickPrevent_koahp7r6y],
      event: 'click.prevent',
    });
  const act_6148282284529915_showModal_kv25pfbu9 =
    new actionTypes.ShowModalAction({
      actionArgs: act_6148282284529915_showModal_kv25pfbu9_getActionArgs,
    });
  const inst_evh_6148282284529915_clickPrevent_4f38lrs04 =
    new actionTypes.EventHandlerImpl({
      action: act_6148282284529915_showModal_kv25pfbu9,
      event: 'click.prevent',
      displayName: 'showModal',
    });
  const inst_evh_6148282284529915_clickPrevent =
    new actionTypes.EventHandlerGroup({
      handlers: [inst_evh_6148282284529915_clickPrevent_4f38lrs04],
      event: 'click.prevent',
    });
  const act_4005034396254503_showModal_ewwo93lm6 =
    new actionTypes.ShowModalAction({
      actionArgs: act_4005034396254503_showModal_ewwo93lm6_getActionArgs,
    });
  const inst_evh_4005034396254503_clickPrevent_srrenoen2 =
    new actionTypes.EventHandlerImpl({
      action: act_4005034396254503_showModal_ewwo93lm6,
      event: 'click.prevent',
      displayName: 'showModal',
    });
  const inst_evh_4005034396254503_clickPrevent =
    new actionTypes.EventHandlerGroup({
      handlers: [inst_evh_4005034396254503_clickPrevent_srrenoen2],
      event: 'click.prevent',
    });
  const act_4368686527809996_showModal_lp197zlxn =
    new actionTypes.ShowModalAction({
      actionArgs: act_4368686527809996_showModal_lp197zlxn_getActionArgs,
    });
  const inst_evh_4368686527809996_clickPrevent_8rxq4su6d =
    new actionTypes.EventHandlerImpl({
      action: act_4368686527809996_showModal_lp197zlxn,
      event: 'click.prevent',
      displayName: 'showModal',
    });
  const inst_evh_4368686527809996_clickPrevent =
    new actionTypes.EventHandlerGroup({
      handlers: [inst_evh_4368686527809996_clickPrevent_8rxq4su6d],
      event: 'click.prevent',
    });
  const act_6106646942169597_showModal_ldw1ywni8 =
    new actionTypes.ShowModalAction({
      actionArgs: act_6106646942169597_showModal_ldw1ywni8_getActionArgs,
    });
  const inst_evh_6106646942169597_clickPrevent_zkocvchtp =
    new actionTypes.EventHandlerImpl({
      action: act_6106646942169597_showModal_ldw1ywni8,
      event: 'click.prevent',
      displayName: 'showModal',
    });
  const inst_evh_6106646942169597_clickPrevent =
    new actionTypes.EventHandlerGroup({
      handlers: [inst_evh_6106646942169597_clickPrevent_zkocvchtp],
      event: 'click.prevent',
    });
  const act_6292004841848118_showModal_s6apwgzms =
    new actionTypes.ShowModalAction({
      actionArgs: act_6292004841848118_showModal_s6apwgzms_getActionArgs,
    });
  const inst_evh_6292004841848118_clickPrevent_2230dfmis =
    new actionTypes.EventHandlerImpl({
      action: act_6292004841848118_showModal_s6apwgzms,
      event: 'click.prevent',
      displayName: 'showModal',
    });
  const inst_evh_6292004841848118_clickPrevent =
    new actionTypes.EventHandlerGroup({
      handlers: [inst_evh_6292004841848118_clickPrevent_2230dfmis],
      event: 'click.prevent',
    });
  const act_968355720031679_showModal_ygyb1id88 =
    new actionTypes.ShowModalAction({
      actionArgs: act_968355720031679_showModal_ygyb1id88_getActionArgs,
    });
  const inst_evh_968355720031679_clickPrevent_q667hx54m =
    new actionTypes.EventHandlerImpl({
      action: act_968355720031679_showModal_ygyb1id88,
      event: 'click.prevent',
      displayName: 'showModal',
    });
  const inst_evh_968355720031679_clickPrevent =
    new actionTypes.EventHandlerGroup({
      handlers: [inst_evh_968355720031679_clickPrevent_q667hx54m],
      event: 'click.prevent',
    });
  const act_3472122993559495_showModal_fcv1q69ao =
    new actionTypes.ShowModalAction({
      actionArgs: act_3472122993559495_showModal_fcv1q69ao_getActionArgs,
    });
  const inst_evh_3472122993559495_clickPrevent_fi4wvb5wy =
    new actionTypes.EventHandlerImpl({
      action: act_3472122993559495_showModal_fcv1q69ao,
      event: 'click.prevent',
      displayName: 'showModal',
    });
  const inst_evh_3472122993559495_clickPrevent =
    new actionTypes.EventHandlerGroup({
      handlers: [inst_evh_3472122993559495_clickPrevent_fi4wvb5wy],
      event: 'click.prevent',
    });
  const act_2096702845922487_showModal_056vpeo7c =
    new actionTypes.ShowModalAction({
      actionArgs: act_2096702845922487_showModal_056vpeo7c_getActionArgs,
    });
  const inst_evh_2096702845922487_clickPrevent_z8a62uz7c =
    new actionTypes.EventHandlerImpl({
      action: act_2096702845922487_showModal_056vpeo7c,
      event: 'click.prevent',
      displayName: 'showModal',
    });
  const inst_evh_2096702845922487_clickPrevent =
    new actionTypes.EventHandlerGroup({
      handlers: [inst_evh_2096702845922487_clickPrevent_z8a62uz7c],
      event: 'click.prevent',
    });

  const actions = {
    inst_evh_7315092382398562_reload_llfuw2t7y,
    inst_evh_7315092382398562_reload,
    inst_evh_1655522927138420_clickPrevent_7pkd4pwra,
    inst_evh_1655522927138420_clickPrevent,
    inst_evh_8017751657993364_clickPrevent_qi77gncy1,
    inst_evh_8017751657993364_clickPrevent,
    inst_evh_7020200672081126_clickPrevent_4ldqq12vd,
    inst_evh_7020200672081126_clickPrevent,
    inst_evh_1664577178787908_clickPrevent_mvnp7o6ni,
    inst_evh_1664577178787908_clickPrevent,
    inst_evh_1573730003820863_clickPrevent_t6tlhg554,
    inst_evh_1573730003820863_clickPrevent,
    inst_evh_3537731272337912_clickPrevent_h5frth5eb,
    inst_evh_3537731272337912_clickPrevent,
    inst_evh_8518026866742051_clickPrevent_owbtpmvk6,
    inst_evh_8518026866742051_clickPrevent,
    inst_evh_8538961222052157_clickPrevent_m65qly0to,
    inst_evh_8538961222052157_clickPrevent,
    inst_evh_8522767679599795_clickPrevent_pd73pwu5k,
    inst_evh_8522767679599795_clickPrevent,
    inst_evh_8019833267266433_clickPrevent_2ygr9ai6s,
    inst_evh_8019833267266433_clickPrevent,
    inst_evh_138351816140972_clickPrevent_jwzj2erz8,
    inst_evh_138351816140972_clickPrevent,
    inst_evh_6701963263207099_clickPrevent_4t2zuwfsv,
    inst_evh_6701963263207099_clickPrevent,
    inst_evh_4779871833378228_clickPrevent_koahp7r6y,
    inst_evh_4779871833378228_clickPrevent,
    inst_evh_6148282284529915_clickPrevent_4f38lrs04,
    inst_evh_6148282284529915_clickPrevent,
    inst_evh_4005034396254503_clickPrevent_srrenoen2,
    inst_evh_4005034396254503_clickPrevent,
    inst_evh_4368686527809996_clickPrevent_8rxq4su6d,
    inst_evh_4368686527809996_clickPrevent,
    inst_evh_6106646942169597_clickPrevent_zkocvchtp,
    inst_evh_6106646942169597_clickPrevent,
    inst_evh_6292004841848118_clickPrevent_2230dfmis,
    inst_evh_6292004841848118_clickPrevent,
    inst_evh_968355720031679_clickPrevent_q667hx54m,
    inst_evh_968355720031679_clickPrevent,
    inst_evh_3472122993559495_clickPrevent_fi4wvb5wy,
    inst_evh_3472122993559495_clickPrevent,
    inst_evh_2096702845922487_clickPrevent_z8a62uz7c,
    inst_evh_2096702845922487_clickPrevent,
  };

  const evh_7315092382398562_reload_llfuw2t7y = async (event, scope) => {
    return await actions.inst_evh_7315092382398562_reload_llfuw2t7y.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_7315092382398562_reload = async (event, scope) => {
    return await actions.inst_evh_7315092382398562_reload.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_1655522927138420_clickPrevent_7pkd4pwra = async (event, scope) => {
    return await actions.inst_evh_1655522927138420_clickPrevent_7pkd4pwra.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_1655522927138420_clickPrevent = async (event, scope) => {
    return await actions.inst_evh_1655522927138420_clickPrevent.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_8017751657993364_clickPrevent_qi77gncy1 = async (event, scope) => {
    return await actions.inst_evh_8017751657993364_clickPrevent_qi77gncy1.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_8017751657993364_clickPrevent = async (event, scope) => {
    return await actions.inst_evh_8017751657993364_clickPrevent.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_7020200672081126_clickPrevent_4ldqq12vd = async (event, scope) => {
    return await actions.inst_evh_7020200672081126_clickPrevent_4ldqq12vd.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_7020200672081126_clickPrevent = async (event, scope) => {
    return await actions.inst_evh_7020200672081126_clickPrevent.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_1664577178787908_clickPrevent_mvnp7o6ni = async (event, scope) => {
    return await actions.inst_evh_1664577178787908_clickPrevent_mvnp7o6ni.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_1664577178787908_clickPrevent = async (event, scope) => {
    return await actions.inst_evh_1664577178787908_clickPrevent.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_1573730003820863_clickPrevent_t6tlhg554 = async (event, scope) => {
    return await actions.inst_evh_1573730003820863_clickPrevent_t6tlhg554.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_1573730003820863_clickPrevent = async (event, scope) => {
    return await actions.inst_evh_1573730003820863_clickPrevent.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_3537731272337912_clickPrevent_h5frth5eb = async (event, scope) => {
    return await actions.inst_evh_3537731272337912_clickPrevent_h5frth5eb.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_3537731272337912_clickPrevent = async (event, scope) => {
    return await actions.inst_evh_3537731272337912_clickPrevent.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_8518026866742051_clickPrevent_owbtpmvk6 = async (event, scope) => {
    return await actions.inst_evh_8518026866742051_clickPrevent_owbtpmvk6.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_8518026866742051_clickPrevent = async (event, scope) => {
    return await actions.inst_evh_8518026866742051_clickPrevent.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_8538961222052157_clickPrevent_m65qly0to = async (event, scope) => {
    return await actions.inst_evh_8538961222052157_clickPrevent_m65qly0to.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_8538961222052157_clickPrevent = async (event, scope) => {
    return await actions.inst_evh_8538961222052157_clickPrevent.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_8522767679599795_clickPrevent_pd73pwu5k = async (event, scope) => {
    return await actions.inst_evh_8522767679599795_clickPrevent_pd73pwu5k.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_8522767679599795_clickPrevent = async (event, scope) => {
    return await actions.inst_evh_8522767679599795_clickPrevent.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_8019833267266433_clickPrevent_2ygr9ai6s = async (event, scope) => {
    return await actions.inst_evh_8019833267266433_clickPrevent_2ygr9ai6s.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_8019833267266433_clickPrevent = async (event, scope) => {
    return await actions.inst_evh_8019833267266433_clickPrevent.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_138351816140972_clickPrevent_jwzj2erz8 = async (event, scope) => {
    return await actions.inst_evh_138351816140972_clickPrevent_jwzj2erz8.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_138351816140972_clickPrevent = async (event, scope) => {
    return await actions.inst_evh_138351816140972_clickPrevent.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_6701963263207099_clickPrevent_4t2zuwfsv = async (event, scope) => {
    return await actions.inst_evh_6701963263207099_clickPrevent_4t2zuwfsv.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_6701963263207099_clickPrevent = async (event, scope) => {
    return await actions.inst_evh_6701963263207099_clickPrevent.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_4779871833378228_clickPrevent_koahp7r6y = async (event, scope) => {
    return await actions.inst_evh_4779871833378228_clickPrevent_koahp7r6y.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_4779871833378228_clickPrevent = async (event, scope) => {
    return await actions.inst_evh_4779871833378228_clickPrevent.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_6148282284529915_clickPrevent_4f38lrs04 = async (event, scope) => {
    return await actions.inst_evh_6148282284529915_clickPrevent_4f38lrs04.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_6148282284529915_clickPrevent = async (event, scope) => {
    return await actions.inst_evh_6148282284529915_clickPrevent.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_4005034396254503_clickPrevent_srrenoen2 = async (event, scope) => {
    return await actions.inst_evh_4005034396254503_clickPrevent_srrenoen2.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_4005034396254503_clickPrevent = async (event, scope) => {
    return await actions.inst_evh_4005034396254503_clickPrevent.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_4368686527809996_clickPrevent_8rxq4su6d = async (event, scope) => {
    return await actions.inst_evh_4368686527809996_clickPrevent_8rxq4su6d.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_4368686527809996_clickPrevent = async (event, scope) => {
    return await actions.inst_evh_4368686527809996_clickPrevent.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_6106646942169597_clickPrevent_zkocvchtp = async (event, scope) => {
    return await actions.inst_evh_6106646942169597_clickPrevent_zkocvchtp.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_6106646942169597_clickPrevent = async (event, scope) => {
    return await actions.inst_evh_6106646942169597_clickPrevent.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_6292004841848118_clickPrevent_2230dfmis = async (event, scope) => {
    return await actions.inst_evh_6292004841848118_clickPrevent_2230dfmis.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_6292004841848118_clickPrevent = async (event, scope) => {
    return await actions.inst_evh_6292004841848118_clickPrevent.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_968355720031679_clickPrevent_q667hx54m = async (event, scope) => {
    return await actions.inst_evh_968355720031679_clickPrevent_q667hx54m.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_968355720031679_clickPrevent = async (event, scope) => {
    return await actions.inst_evh_968355720031679_clickPrevent.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_3472122993559495_clickPrevent_fi4wvb5wy = async (event, scope) => {
    return await actions.inst_evh_3472122993559495_clickPrevent_fi4wvb5wy.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_3472122993559495_clickPrevent = async (event, scope) => {
    return await actions.inst_evh_3472122993559495_clickPrevent.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_2096702845922487_clickPrevent_z8a62uz7c = async (event, scope) => {
    return await actions.inst_evh_2096702845922487_clickPrevent_z8a62uz7c.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_2096702845922487_clickPrevent = async (event, scope) => {
    return await actions.inst_evh_2096702845922487_clickPrevent.executeFromDOM(
      $component,
      event,
      scope
    );
  };

  defineExpose({
    loadData,
    loading,
    loaded,
    error,
  });
</script>

<template>
  <ItpUsercontrol
    :loading="loading"
    :reloading="reloading"
    :loaded="loaded"
    :error="error"
    loadingPlaceholder="none"
    @reload="evh_7315092382398562_reload($event, {})"
  >
    <BNavbarNav>
      <BNavItemDropdown>
        <template #button-content>
          {{ pgettext('MainMenu', 'Finance') }}
        </template>
        <ItpDropdownText>
          {{ pgettext('MainMenu', 'Register') }}
        </ItpDropdownText>
        <ItpNavItem
          to="/registers"
          :icon="$config.register.icon"
          :text="pgettext('MainMenu', 'Registers')"
          dropdown-item
        >
        </ItpNavItem>
        <ItpDropdownDivider> </ItpDropdownDivider>
        <ItpDropdownText>
          {{ pgettext('MainMenu', 'Customer invoices') }}
        </ItpDropdownText>
        <ItpNavItem
          to="/invoices-out"
          :icon="$config.invoice.customerInvoiceIcon"
          :text="pgettext('MainMenu', 'Customer invoices')"
          dropdown-item
        >
        </ItpNavItem>
        <ItpNavItem
          :text="pgettext('MainMenu', 'New Customer Invoice...')"
          :icon="$config.invoice.customerInvoiceIcon"
          dropdown-item
          @click.prevent="evh_1655522927138420_clickPrevent($event, {})"
        >
        </ItpNavItem>
        <ItpNavItem
          to="/billing-list"
          :icon="$config.billingList.icon"
          :text="pgettext('MainMenu', 'Billing List')"
          dropdown-item
        >
        </ItpNavItem>
        <ItpNavItem
          to="/invoice-generation"
          :icon="$config.invoiceGeneration.icon"
          :text="pgettext('MainMenu', 'Invoice Generation')"
          dropdown-item
        >
        </ItpNavItem>
        <ItpDropdownDivider> </ItpDropdownDivider>
        <ItpDropdownText>
          {{ pgettext('MainMenu', 'Incoming invoices') }}
        </ItpDropdownText>
        <ItpNavItem
          to="/invoices-in"
          :icon="$config.invoice.vendorInvoiceIcon"
          :text="pgettext('MainMenu', 'Incoming invoices')"
          dropdown-item
        >
        </ItpNavItem>
        <ItpNavItem
          :text="pgettext('MainMenu', 'New Incoming Invoice...')"
          :icon="$config.invoice.icon"
          dropdown-item
          @click.prevent="evh_8017751657993364_clickPrevent($event, {})"
        >
        </ItpNavItem>
        <ItpDropdownDivider> </ItpDropdownDivider>
        <ItpDropdownText>
          {{ pgettext('MainMenu', 'Payments') }}
        </ItpDropdownText>
        <ItpNavItem
          to="/payments"
          :icon="$config.payment.paymentsList.icon"
          :text="pgettext('PaymentsView', 'Payments')"
          dropdown-item
        >
        </ItpNavItem>
        <ItpNavItem
          to="/accounts-daily-flow"
          :icon="$config.accountsDailyFlow.icon"
          :text="pgettext('MainMenu', 'Accounts Daily Flow')"
          dropdown-item
        >
        </ItpNavItem>
        <ItpNavItem
          :text="pgettext('Create Payment', 'New Cash In...')"
          :icon="$config.payment.cash.icon"
          dropdown-item
          @click.prevent="evh_7020200672081126_clickPrevent($event, {})"
        >
        </ItpNavItem>
        <ItpNavItem
          :text="pgettext('Create Payment', 'New Cash Out...')"
          :icon="$config.payment.cash.icon"
          dropdown-item
          @click.prevent="evh_1664577178787908_clickPrevent($event, {})"
        >
        </ItpNavItem>
        <ItpNavItem
          :text="pgettext('Create Payment', 'New Banking...')"
          :icon="$config.payment.banking.icon"
          dropdown-item
          @click.prevent="evh_1573730003820863_clickPrevent($event, {})"
        >
        </ItpNavItem>
        <ItpNavItem
          :text="pgettext('MeinMenu', 'Account statement report...')"
          :icon="$config.accountStatementReport.icon"
          dropdown-item
          @click.prevent="evh_3537731272337912_clickPrevent($event, {})"
        >
        </ItpNavItem>
        <ItpDropdownDivider> </ItpDropdownDivider>
        <ItpDropdownText>
          {{ pgettext('MainMenu', 'Claims management') }}
        </ItpDropdownText>
        <ItpNavItem
          to="/claims"
          :icon="$config.claim.icon"
          :text="pgettext('MainMenu', 'Claims')"
          dropdown-item
        >
        </ItpNavItem>
        <ItpNavItem
          to="/dunning-letters"
          :icon="$config.dunningLetter.icon"
          :text="pgettext('MainMenu', 'Dunning letters')"
          dropdown-item
        >
        </ItpNavItem>
      </BNavItemDropdown>
      <BNavItemDropdown>
        <template #button-content>
          {{ pgettext('MainMenu', 'Assets') }}
        </template>
        <ItpNavItem
          to="/fixed-assets"
          :icon="$config.fixedAsset.icon"
          :text="pgettext('MainMenu', 'Fixed Assets')"
          dropdown-item
        >
        </ItpNavItem>
        <ItpNavItem
          :text="pgettext('MainMenu', 'Create Asset...')"
          :icon="$config.fixedAsset.icon"
          dropdown-item
          @click.prevent="evh_8518026866742051_clickPrevent($event, {})"
        >
        </ItpNavItem>
        <ItpDropdownDivider> </ItpDropdownDivider>
        <ItpNavItem
          to="/waste-bins"
          :icon="$config.wasteBin.icon"
          :text="pgettext('MainMenu', 'Waste Bins')"
          dropdown-item
        >
        </ItpNavItem>
        <ItpNavItem
          to="/waste-bin-readings"
          :icon="$config.wasteBin.icon"
          :text="pgettext('MainMenu', 'Waste Bin Readings')"
          dropdown-item
        >
        </ItpNavItem>
        <ItpNavItem
          :text="pgettext('MainMenu', 'Create Waste Bin...')"
          :icon="$config.wasteBin.createWasteBinIcon"
          dropdown-item
          @click.prevent="evh_8538961222052157_clickPrevent($event, {})"
        >
        </ItpNavItem>
        <ItpDropdownDivider> </ItpDropdownDivider>
        <ItpDropdownText>
          {{ pgettext('MainMenu', 'Meters') }}
        </ItpDropdownText>
        <ItpNavItem
          to="/meters"
          :icon="$config.meter.icon"
          :text="pgettext('MainMenu', 'Meters')"
          dropdown-item
        >
        </ItpNavItem>
        <ItpNavItem
          :text="pgettext('MainMenu', 'Add Meter...')"
          :icon="$config.meter.addMeterIcon"
          dropdown-item
          @click.prevent="evh_8522767679599795_clickPrevent($event, {})"
        >
        </ItpNavItem>
        <ItpNavItem
          href="#"
          :icon="$config.meterReplacement.icon"
          :text="pgettext('MainMenu', 'Replace meter...')"
          dropdown-item
          @click.prevent="evh_8019833267266433_clickPrevent($event, {})"
        >
        </ItpNavItem>
        <ItpNavItem
          to="/auto-readings"
          :icon="$config.meterAutoReading.icon"
          :text="pgettext('MainMenu', 'Auto Readings')"
          dropdown-item
        >
        </ItpNavItem>
        <ItpNavItem
          href="#"
          icon="fa-upload"
          :text="pgettext('MainMenu', 'Meter Data Exchange...')"
          dropdown-item
          @click.prevent="evh_138351816140972_clickPrevent($event, {})"
        >
        </ItpNavItem>
        <ItpNavItem
          to="/meter-consumptions"
          :icon="$config.meterConsumption.icon"
          :text="pgettext('MainMenu', 'Meter consumptions')"
          dropdown-item
        >
        </ItpNavItem>
      </BNavItemDropdown>
      <BNavItemDropdown>
        <template #button-content>
          {{ pgettext('MainMenu', 'Contracts') }}
        </template>
        <ItpNavItem
          to="/contracts"
          :icon="$config.contract.icon"
          :text="pgettext('MainMenu', 'Contracts')"
          dropdown-item
        >
        </ItpNavItem>
        <ItpNavItem
          :text="pgettext('MainMenu', 'Create Contract...')"
          :icon="$config.contract.icon"
          dropdown-item
          @click.prevent="evh_6701963263207099_clickPrevent($event, {})"
        >
        </ItpNavItem>
        <ItpNavItem
          to="/contract-services"
          :icon="$config.contract.icon"
          :text="pgettext('MainMenu', 'Contract services')"
          dropdown-item
        >
        </ItpNavItem>
        <ItpNavItem
          to="/contract-service-fees"
          :icon="$config.contract.icon"
          :text="pgettext('MainMenu', 'Contract service fees')"
          dropdown-item
        >
        </ItpNavItem>
        <ItpNavItem
          to="/contract-attachments"
          :icon="$config.attachmentIcon"
          :text="pgettext('MainMenu', 'Contract attachments')"
          dropdown-item
        >
        </ItpNavItem>
        <ItpNavItem
          to="/contract-events"
          :icon="$config.contract.views.contractEvents.icon"
          :text="pgettext('MainMenu', 'Contract events')"
          dropdown-item
        >
        </ItpNavItem>
        <ItpDropdownDivider> </ItpDropdownDivider>
        <ItpNavItem
          to="/overlapping-revisions"
          :icon="$config.contract.views.overlappingRevisions.icon"
          :text="pgettext('MainMenu', 'Overlapping Revisions')"
          dropdown-item
        >
        </ItpNavItem>
        <ItpNavItem
          href="#"
          icon="gravity-ui:curly-brackets-function"
          :text="pgettext('MainMenu', 'Billing rules')"
          dropdown-item
          @click.prevent="evh_4779871833378228_clickPrevent($event, {})"
        >
        </ItpNavItem>
      </BNavItemDropdown>
      <BNavItemDropdown>
        <template #button-content>
          {{ pgettext('MainMenu', 'Worksheets') }}
        </template>
        <ItpNavItem
          to="/worksheets"
          :icon="$config.worksheet.icon"
          :text="pgettext('MainMenu', 'Worksheets')"
          dropdown-item
        >
        </ItpNavItem>
        <ItpNavItem
          :text="pgettext('MainMenu', 'New Worksheet...')"
          :icon="$config.worksheet.createWorksheetIcon"
          dropdown-item
          @click.prevent="evh_6148282284529915_clickPrevent($event, {})"
        >
        </ItpNavItem>
        <ItpNavItem
          to="/worksheets-work-summary"
          :icon="$config.worksheet.icon"
          :text="pgettext('MainMenu', 'Work summary')"
          dropdown-item
        >
        </ItpNavItem>
      </BNavItemDropdown>
      <BNavItemDropdown>
        <template #button-content>
          {{ pgettext('MainMenu', 'Master data') }}
        </template>
        <ItpNavItem
          to="/products"
          :icon="$config.product.icon"
          :text="pgettext('MainMenu', 'Products')"
          dropdown-item
        >
        </ItpNavItem>
        <ItpNavItem
          :text="pgettext('MainMenu', 'New product/service...')"
          :icon="$config.product.addProductIcon"
          dropdown-item
          @click.prevent="evh_4005034396254503_clickPrevent($event, {})"
        >
        </ItpNavItem>
        <ItpNavItem
          :text="pgettext('MainMenu', 'Tariffs...')"
          :icon="$config.tariff.icon"
          dropdown-item
          @click.prevent="evh_4368686527809996_clickPrevent($event, {})"
        >
        </ItpNavItem>
        <ItpDropdownDivider> </ItpDropdownDivider>
        <ItpNavItem
          to="/rentals"
          :icon="$config.rental.icon"
          :text="pgettext('MainMenu', 'Rentals')"
          dropdown-item
        >
        </ItpNavItem>
        <ItpNavItem
          :text="pgettext('MainMenu', 'Add Rental...')"
          :icon="$config.rental.addRentalIcon"
          dropdown-item
          @click.prevent="evh_6106646942169597_clickPrevent($event, {})"
        >
        </ItpNavItem>
        <ItpNavItem
          to="/rental-services"
          :icon="$config.rental.icon"
          :text="pgettext('MainMenu', 'Rental services')"
          dropdown-item
        >
        </ItpNavItem>
        <ItpDropdownDivider> </ItpDropdownDivider>
        <ItpNavItem
          to="/projects"
          :icon="$config.project.icon"
          :text="pgettext('MainMenu', 'Projects')"
          dropdown-item
        >
        </ItpNavItem>
        <ItpNavItem
          :text="pgettext('MainMenu', 'Add project...')"
          :icon="$config.project.addProjectIcon"
          dropdown-item
          @click.prevent="evh_6292004841848118_clickPrevent($event, {})"
        >
        </ItpNavItem>
        <ItpDropdownDivider> </ItpDropdownDivider>
        <ItpNavItem
          to="/properties"
          :icon="$config.property.icon"
          :text="pgettext('MainMenu', 'Locations')"
          dropdown-item
        >
        </ItpNavItem>
        <ItpNavItem
          :text="pgettext('MainMenu', 'Add property...')"
          :icon="$config.property.addPropertyIcon"
          dropdown-item
          @click.prevent="evh_968355720031679_clickPrevent($event, {})"
        >
        </ItpNavItem>
        <ItpDropdownDivider> </ItpDropdownDivider>
        <ItpNavItem
          to="/partners"
          :icon="$config.company.icons.partner"
          :text="pgettext('MainMenu', 'Partners')"
          dropdown-item
        >
        </ItpNavItem>
        <ItpNavItem
          :text="pgettext('MainMenu', 'Add partner...')"
          :icon="$config.company.icons.partner"
          dropdown-item
          @click.prevent="evh_3472122993559495_clickPrevent($event, {})"
        >
        </ItpNavItem>
        <ItpDropdownDivider> </ItpDropdownDivider>
        <ItpNavItem
          to="/own-companies"
          :icon="$config.company.icons.own"
          :text="pgettext('MainMenu', 'Own companies')"
          dropdown-item
        >
        </ItpNavItem>
        <ItpNavItem
          :text="pgettext('MainMenu', 'Add company...')"
          :icon="$config.company.icons.own"
          dropdown-item
          @click.prevent="evh_2096702845922487_clickPrevent($event, {})"
        >
        </ItpNavItem>
      </BNavItemDropdown>
      <Charts> </Charts>
    </BNavbarNav>
  </ItpUsercontrol>
</template>
